import { axios, transformAxiosError } from "@/utils/axios.create";

export interface TreatmentAgencyAddress {
  _id: string;
  name: string;
  address?: string;
  email?: string;
  phone?: string;
  latitude?: number;
  longitude?: number;
}

export interface TreatmentAgency {
  _id: string;
  name: string;
}

interface TreatmentAgenciesResponse {
  agencies: (TreatmentAgency & { addresses?: TreatmentAgencyAddress[] })[];
}

interface TreatmentAgencyAddressesResponse {
  addresses: TreatmentAgencyAddress[];
}

const getTreatmentAgencies = async (params: {
  accountId: string;
  userId: string;
}): Promise<TreatmentAgenciesResponse> => {
  try {
    const response = await axios.get(
      `/participants/${params.userId}/treatment-agencies`
    );
    return response.data.body;
  } catch (error) {
    throw transformAxiosError(error as Error);
  }
};

const getTreatmentAgencyAddresses = async (params: {
  accountId: string;
  userId: string;
  agencyId: string;
}): Promise<TreatmentAgencyAddressesResponse> => {
  try {
    const response = await axios.get(
      `/participants/${params.userId}/treatment-agencies/${params.agencyId}/addresses`
    );
    return response.data.body;
  } catch (error) {
    throw transformAxiosError(error as Error);
  }
};

const TreatmentAgenciesService = {
  getTreatmentAgencies,
  getTreatmentAgencyAddresses,
};

export default TreatmentAgenciesService;
